module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/redirect/redirect.component.css
// module id = ./src/app/redirect/redirect.component.css
// module chunks = main